module.exports = __webpack_public_path__ + "static/media/3.c6ee7a96.png";